module.exports = new __parcel__URL__("42845_sq.339bafde.jpg").toString();